var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1 1.33331 5 5 5-5","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronDown.defaultProps = {"width":"12","height":"7","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
